<template>
    <div>
        <div v-if="canEdit" style="display: flex; align-items: center">
            <el-button v-model="vo" v-listpage-dialog style="margin-right: 10px" listviewurl="dagl.contractFiles.list?urlsearch=contractType:1" dialog-title="合同档案" exclude-fields="status" :multiple="false" name="selectTask">
                <i class="el-icon-plus el-icon--left" style="color: #198618; font-weight: bold"></i>
                选择合同档案
            </el-button>
            <el-upload ref="uploadRef" class="upload-demo" action="#" :on-change="fileChange" :auto-upload="false" :on-remove="handleRemove" :multiple="true" :file-list="vo.passenger.attachments" :show-file-list="false">
                <el-button>
                    <i class="el-icon-plus el-icon--left" style="color: #198618; font-weight: bold"></i>
                    上传合同文件
                </el-button>
            </el-upload>
        </div>
        <div v-if="vo && contractAttachs.length > 0">
            <div v-for="(attach, index) in contractAttachs" :key="index">
                <el-link type="primary" @click="download(attach)">{{ attach.fileName }}</el-link>
                <span v-if="canEdit" class="remove-button" style="color: red; margin-left: 10px" @click="handleRemove(attach, vo)">x</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputWithHistory',
    props: {
        vo: {
            type: Object,
            default: () => ({})
        },
        canEdit: { type: Number, default: 1 },
        baseUrl: { type: String, default: null }
    },
    data() {
        return {
            module: 'zjxmArch',
            updated: true,
            moduleType: ''
        }
    },
    computed: {
        contractAttachs() {
            if (this.vo.passenger.attachments) {
                return this.vo.passenger.attachments.filter((item) => item.fileType === '招标合同' || item.fileType === '合同')
            } else {
                return []
            }
        }
    },
    mounted() {
        setTimeout(() => {
            const upload = document.querySelector('.el-upload')
            if (upload && upload.parentNode.style.display === 'contents') {
                upload.parentNode.style.display = 'inline-block'
                upload.parentNode.style.float = ''
            }
        }, 100)
    },
    methods: {
        truncateFileName(fileName) {
            // 这里只是一个简单的示例，你可以根据需要调整逻辑
            const maxLength = 20 // 你可以设置你想要的最大长度
            if (fileName.length > maxLength) {
                return fileName.substring(0, maxLength) + '...'
            }
            return fileName
        },
        fileChange(files, fileList) {
            if (fileList.length > 0) {
                this.uploadAttach([files])

                console.log(files, fileList)
            }
        },
        uploadAttach(fileList) {
            fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', this.module)
                fd.append('busiDataId', this.vo.id)
                fd.append('attachsType', '招标合同')
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)

                this.$http({
                    method: 'post',
                    url: '/' + this.baseUrl + '/' + this.module + '/upload',
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.moduleType = 2
                        this.$message.success(res.message)
                        // 如果attachments数组还不存在，则创建它
                        if (!this.vo.passenger.attachments) {
                            this.$set(this.vo.passenger, 'attachments', [{}])
                        }
                        this.vo.invoiceId = res.body.invoiceId
                        // this.vo.passenger.attachments = [...res.body.uploadAttachList]
                        this.$set(this.vo.passenger, 'attachments', [...this.vo.passenger.attachments, ...res.body.uploadAttachList])
                        this.vo.fileSize = res.body.uploadAttachList[0].fileSize
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        handleRemove(attach, vo) {
            this.$confirm('您是否确认删除附件？', this.$tx('common.confirmOperate', '确认操作'), { type: 'warning' }).then(() => {
                if (this.vo.contractId === attach.busiDataId) {
                    let attachments = this.vo.passenger.attachments.filter((item) => item.id !== attach.id)
                    this.$set(this.vo.passenger, 'attachments', attachments)
                    this.$message.success('删除成功')
                } else {
                    this.$bus.emit('showDoingDialog')
                    this.$http({
                        method: 'delete',
                        url: '/' + this.baseUrl + '/' + this.module + '/deleteAttach',
                        params: {
                            attachIds: attach.id
                        }
                    }).then((res) => {
                        this.$bus.emit('closeDoingDialog')
                        if (res.code === 'success') {
                            this.updated = false
                            this.$message.success(res.message)
                            // this.vo.passenger.attachments = []

                            let attachments = this.vo.passenger.attachments.filter((item) => item.id !== attach.id)
                            this.$set(this.vo.passenger, 'attachments', attachments)
                            this.$nextTick(() => {
                                this.updated = true
                            })
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            })
        },
        download(attach) {
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/' + this.baseUrl + '/' + this.module + '/downloadById?inline=true&attachIds=' + attach.id)
        },
        onSelectListpageRowCompleted(val, arr) {
            this.moduleType = 1
            this.$set(this.vo, 'contractName', val[0].contractName)
            this.$set(this.vo, 'contractId', val[0].id)
            this.$set(this.vo, 'contractAmount', val[0].projectAmount)
            this.$set(this.vo, 'concludeDate', val[0].concludeDate)

            this.getData(val[0].id)
        },
        getData(id) {
            this.$http({
                method: 'get',
                url: 'dagl/contractFiles/getById',
                params: {
                    id: id
                }
            }).then((res) => {
                if (res.code === 'success') {
                    if (!this.vo.passenger.attachments) {
                        this.$set(this.vo.passenger, 'attachments', [])
                    }

                    if (res.body.vo.passenger.attachments.length > 0) {
                        res.body.vo.passenger.attachments.forEach((attach) => {
                            if (attach.fileType === '合同') {
                                attach.busiDataId = this.vo.id
                                attach.passenger.copyAttach = 1
                                this.vo.passenger.attachments.push(attach)
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
div {
    line-height: 25px !important;
}
.el-autocomplete {
    display: flex;
}

.history-item {
    display: flex;
    align-items: center;
    // padding: 8px 0;
    cursor: pointer;

    .history-icon {
        color: #909399;
        margin-right: 8px;
        font-size: 14px;
    }

    .history-text {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .history-delete {
        color: #909399;
        opacity: 0;
        transition: opacity 0.2s;
        font-size: 12px;
        cursor: pointer;

        &:hover {
            color: #f56c6c;
        }
    }

    &:hover .history-delete {
        opacity: 1;
    }
}
</style>

<style lang="scss">
.el-upload {
    display: flex;
    align-items: center;
}

.history-autocomplete-popper {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e4e7ed !important;
    padding: 4px 0 !important;

    .el-autocomplete-suggestion__wrap {
        padding: 4px 0;
    }

    li {
        line-height: 36px !important;
        padding: 0 12px !important;

        &:hover {
            background-color: #f5f7fa !important;
        }

        &.highlighted {
            background-color: #ecf5ff !important;
        }
    }

    .popper__arrow {
        display: none;
    }
}
</style>
